<template>
  <div id="Trend">
    <Spin fix v-if="loading.page">
      <div class="loader">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="5" stroke-miterlimit="10" />
        </svg>
      </div>
    </Spin>
    <div class="header">
      <div :class="device == 'mobile' ? 'mobile-top top' : 'top'">
        <div style="display:flex">
          <div class="avatar" v-if="device != 'mobile'">
            <div class="avatarInside">
              <!-- <img :src="dataSource.imgUrl" alt> -->
              <img v-lazy="{ src: qiniuUrl + dataSource.newKcImg }" alt />
            </div>
          </div>
          <div class="info">
            <!-- <p class="name">{{dataSource.gameType}}</p> -->
            <p class="name">{{ dataSource.newKcName }}</p>
            <p class="lastissue">
              第
              <span>{{ dataSource.lastResultIssueID }}</span>
              期开奖
            </p>
            <ResBall :showTime="showTime" class="res" :type="betType" :dataSource="dataSource"></ResBall>
          </div>
        </div>
        <div :class="device == 'mobile' ? 'times mobile-times' : 'times'">
          <div>
            <p class="issue">
              距
              <!-- <em>{{dataSource.issueID}}</em> -->
              <em>{{ Number(dataSource.lastResultIssueID) + 1 }}</em>
              期开奖仅有
            </p>
            <div class="time" v-html="showTimeDom"></div>
            <!-- 双色球 六合彩系列一天只开一期，故不显示剩余期数 bug:1001011 -->
            <div v-if="device !== 'mobile' && betType !== 'three' && betType !== 'lhc'">
              <span>当前{{ dataSource.todaySeq }}期，剩余{{ dataSource.issueNum - dataSource.todaySeq }}期</span>
            </div>
            <div v-if="device !== 'mobile'">
              <span v-if="betType == 'three'">每天晚上20:20开奖</span>
              <span v-else-if="betType == 'lhc'">每周2,4,6晚上21：30开奖</span>
            </div>
          </div>
          <div
            v-if="videoImg && betType != 'lhc' && betType != 'three'"
            style="cursor:pointer"
            @click="
              () => {
                (showBigVideo = true), (showSmallVideo = false);
              }
            "
          >
            <img :src="videoImg" />
          </div>
        </div>
      </div>
      <div :class="device == 'mobile' ? 'handles mobile-handles' : 'handles'">
        <ul v-if="device != 'mobile'">
          <li v-for="(it, i) in menus" @click="goto(it.alias)" :class="{ active: modeType == it.alias }">{{ it.name }}</li>
        </ul>
        <ul v-else>
          <li v-for="(it, i) in menus.slice(0, 4)" @click="goto(it.alias, i)" :class="{ active: modeType == it.alias }">{{ it.name }}</li>
        </ul>
        <div class="menu-icon" :style="!showMobileMenu ? showMobileMenuImg : closeMobileMenuImg" @click="showMobileMenu = !showMobileMenu"></div>
      </div>
      <div class="mobile-menu" v-if="showMobileMenu && device == 'mobile'">
        <div class="item" v-for="(it, i) in menus" @click="goto(it.alias)" :class="{ active: modeType == it.alias }">{{ it.name }}</div>
      </div>
    </div>
    <div :class="device == 'mobile' ? 'mobile-advertising advertising' : 'advertising'">
      <img @click="handleLinkSite(bannerList[9])" v-if="bannerList[9]" :src="qiniuUrl + bannerList[9].imgUrl" />
      <img @click="handleLinkSite(bannerList[10])" v-if="bannerList[10]" :src="qiniuUrl + bannerList[10].imgUrl" />
    </div>
    <div class="container">
      <Spin fix v-if="loading.mode">
        <div class="loadingbox"></div>
      </Spin>
      <!-- 六合彩立即开奖，历史数据单独写的 -->
      <History ref="History" v-if="modeType == 'History' && betType != 'lhc'"></History>
      <KSjibenzoushi ref="Jibenzoushi" v-if="modeType == 'Jibenzoushi' && betType == 'ks'"></KSjibenzoushi>
      <Jibenzoushi ref="Jibenzoushi" v-if="modeType == 'Jibenzoushi' && betType != 'ks'"></Jibenzoushi>
      <Jishikaijiang ref="Jishikaijiang" v-if="modeType == 'Jishikaijiang'"></Jishikaijiang>
      <Lenrefenxi ref="Lenrefenxi" v-if="modeType == 'Lenrefenxi'"></Lenrefenxi>
      <Lishikaijiang ref="Lishikaijiang" v-if="modeType == 'Lishikaijiang'"></Lishikaijiang>
      <Luzhufenxi ref="Luzhufenxi" v-if="modeType == 'Luzhufenxi'"></Luzhufenxi>
      <Zonghefenxi ref="Zonghefenxi" v-if="modeType == 'Zonghefenxi'"></Zonghefenxi>
      <Haomaluzhu ref="Haomaluzhu" v-if="modeType == 'Haomaluzhu'"></Haomaluzhu>

      <Xingtaizoushi ref="Xingtaizoushi" v-if="modeType == 'Xingtaizoushi'"></Xingtaizoushi>
      <Longhuzoushi @checkAllGroupChange="checkAllGroupChange" ref="Longhuzoushi" v-if="modeType == 'Longhuzoushi'"></Longhuzoushi>
      <Dingweizoushi ref="Dingweizoushi" v-if="modeType == 'Dingweizoushi'"></Dingweizoushi>
      <Daxiaodanshuanglishi ref="Daxiaodanshuanglishi" v-if="modeType == 'Daxiaodanshuanglishi'"></Daxiaodanshuanglishi>
      <Hezhizoushi ref="Hezhizoushi" v-if="modeType == 'Hezhizoushi'"></Hezhizoushi>
      <Haomatongji ref="Haomatongji" v-if="modeType == 'Haomatongji'"></Haomatongji>
      <Lishihaomatongji ref="Lishihaomatongji" v-if="modeType == 'Lishihaomatongji'"></Lishihaomatongji>
      <Meirichanglongtongji ref="Meirichanglongtongji" v-if="modeType == 'Meirichanglongtongji'"></Meirichanglongtongji>
      <Liangmianshujutongji ref="Liangmianshujutongji" v-if="modeType == 'Liangmianshujutongji'"></Liangmianshujutongji>
      <Zongheluzhu ref="Zongheluzhu" v-if="modeType == 'Zongheluzhu'"></Zongheluzhu>
      <Daxiaozhoushi ref="Daxiaozhoushi" v-if="modeType == 'Daxiaozhoushi'"></Daxiaozhoushi>
      <Jiouzoushi @checkAllGroupChange="checkAllGroupChange" ref="Jiouzoushi" v-if="modeType == 'Jiouzoushi'"></Jiouzoushi>
      <Longhutongji ref="Longhutongji" v-if="modeType == 'Longhutongji'"></Longhutongji>
      <Haomaqianhouluzhu ref="Haomaqianhouluzhu" v-if="modeType == 'Haomaqianhouluzhu'"></Haomaqianhouluzhu>
      <Haomaguilvtongji ref="Haomaguilvtongji" v-if="modeType == 'Haomaguilvtongji'"></Haomaguilvtongji>
      <LhcJishikaijiang ref="LhcJishikaijiang" v-if="modeType == 'LhcJishikaijiang' || modeType == 'LhcHistory'"></LhcJishikaijiang>
      <Haomafenbu ref="Haomafenbu" v-if="modeType == 'Haomafenbu'"></Haomafenbu>
      <Heshudanshuangluzhu ref="Heshudanshuangluzhu" v-if="modeType == 'Heshudanshuangluzhu'"></Heshudanshuangluzhu>
      <Longhuluzhu ref="Longhuluzhu" v-if="modeType == 'Longhuluzhu'"></Longhuluzhu>
      <HPZongheluzhu ref="HPZongheluzhu" v-if="modeType == 'HPZongheluzhu'"></HPZongheluzhu>
      <weishuluzhu ref="weishuluzhu" v-if="modeType == 'weishuluzhu'"></weishuluzhu>
      <zhongfabailuzhu ref="zhongfabailuzhu" v-if="modeType == 'zhongfabailuzhu'"></zhongfabailuzhu>
      <dongnanxibeiluzhu ref="dongnanxibeiluzhu" v-if="modeType == 'dongnanxibeiluzhu'"></dongnanxibeiluzhu>
      <Daxiaodanshuangluzhu ref="Daxiaodanshuangluzhu" v-if="modeType == 'Daxiaodanshuangluzhu'"></Daxiaodanshuangluzhu>
    </div>
    <Modal v-model="showBigVideo" width="1000" footer-hide>
      <div slot="header" style="color:#f60;text-align:center;height:20px;">
        <div style="float:left">
          <Button
            type="info"
            @click="
              () => {
                showSmallVideo = true;
                showBigVideo = false;
              }
            "
            >小屏</Button
          >
        </div>
        <span>开奖视频</span>
      </div>
      <!-- scrolling="no"  frameborder="no" -->
      <div style="text-align:center">
        <iframe v-if="showBigVideo" :src="videoUrl" scrolling="no"></iframe>
      </div>
    </Modal>
    <div v-if="showSmallVideo" class="small-video">
      <div class="video-header">
        <Button
          type="info"
          @click="
            () => {
              showSmallVideo = false;
              showBigVideo = true;
            }
          "
          >中屏</Button
        >
        <p @click="showSmallVideo = false">×</p>
      </div>
      <iframe :src="videoUrl" frameborder="no" scrolling="no" style="width:100%;height:100%;"></iframe>
    </div>
  </div>
</template>
<script>
import getBetType from '../../helpers/getBetType.js';
import ResBall from '../../components/ResBall';
import { formatSeconds } from '../../helpers/util.js';

import History from './History';
import Jibenzoushi from './Jibenzoushi';
import Jishikaijiang from './Jishikaijiang';
import Lenrefenxi from './Lenrefenxi';
import Lishikaijiang from './Lishikaijiang';
import Luzhufenxi from './Luzhufenxi';
import Zonghefenxi from './Zonghefenxi';
import Haomaluzhu from './Haomaluzhu';
import Daxiaodanshuanglishi from './Daxiaodanshuanglishi';
import Xingtaizoushi from './Xingtaizoushi';
import Longhuzoushi from './Longhuzoushi';
import Dingweizoushi from './Dingweizoushi';
import Hezhizoushi from './Hezhizoushi';
import Haomatongji from './Haomatongji';
import Lishihaomatongji from './Lishihaomatongji';
import Meirichanglongtongji from './Meirichanglongtongji';
import Liangmianshujutongji from './Liangmianshujutongji';
import Zongheluzhu from './Zongheluzhu';
import Daxiaozhoushi from './Daxiaozhoushi';
import Jiouzoushi from './Jiouzoushi';
import Longhutongji from './Longhutongji';
import Haomaqianhouluzhu from './Haomaqianhouluzhu';
import Haomaguilvtongji from './Haomaguilvtongji';
import LhcJishikaijiang from './LhcJishikaijiang';
import Haomafenbu from './Haomafenbu';
import Heshudanshuangluzhu from './Heshudanshuangluzhu';
import Longhuluzhu from './Longhuluzhu';
import HPZongheluzhu from './HPZongheluzhu';
import weishuluzhu from './weishuluzhu';
import zhongfabailuzhu from './zhongfabailuzhu';
import dongnanxibeiluzhu from './dongnanxibeiluzhu';
import Daxiaodanshuangluzhu from './Daxiaodanshuangluzhu';
import KSjibenzoushi from './KSjibenzoushi';
import menus from '../../helpers/trendMenus.js';
import { mapState } from 'vuex';
import dayjs from 'dayjs';
import { count, smallBig, dragonTiger } from '../../helpers/resPatterns.js';
import GenerateData from './helpers/generateData.js';
export default {
  name: 'Trend',
  components: {
    KSjibenzoushi,
    ResBall,
    History,
    Jibenzoushi,
    Jishikaijiang,
    Lenrefenxi,
    Lishikaijiang,
    Luzhufenxi,
    Zonghefenxi,
    Haomaluzhu,
    Daxiaodanshuanglishi,
    Xingtaizoushi,
    Longhuzoushi,
    Dingweizoushi,
    Hezhizoushi,
    Haomatongji,
    Lishihaomatongji,
    Meirichanglongtongji,
    Liangmianshujutongji,
    Zongheluzhu,
    Daxiaozhoushi,
    Jiouzoushi,
    // Guanyahezoushi,
    Longhutongji,
    Haomaqianhouluzhu,
    Haomaguilvtongji,
    LhcJishikaijiang,
    Haomafenbu,
    Heshudanshuangluzhu,
    Longhuluzhu,
    HPZongheluzhu,
    weishuluzhu,
    zhongfabailuzhu,
    dongnanxibeiluzhu,
    Daxiaodanshuangluzhu
  },
  watch: {
    $route: {
      immediate: true,
      handler(olddata, newdata) {
        this.init();
      }
    },
    showBigVideo() {
      if (this.showBigVideo) {
        this.initIframe();
      }
    },
    showSmallVideo() {
      if (this.showSmallVideo) {
        this.initIframe();
      }
    },
    //开奖状态监听
    isOpen() {
      if (this.isOpen == false && (this.betType != 'lhc' || this.betType != 'three')) {
        // console.log("isOpen", this.isOpen);
        const $iframe = document.querySelector('iframe');
        const data = GenerateData[this.betType](this);
        $iframe.contentWindow.pubmethod.init(this.betType, data, {
          flag: true
        });
      }
    }
  },
  data() {
    return {
      loading: {
        page: false,
        mode: false
      },
      videoUrl: '',
      videoImg: require('../../assets/img/ssc.png'),
      isOpen: false, //开奖状态
      showSmallVideo: false,
      showBigVideo: false,
      showMobileMenu: false,
      modeType: '',
      dataSource: {},
      timeDown: null,
      openTime: 1000,
      resTimeOut: null,
      second: 0,
      showTime: '',
      curIdx: 0,
      showMobileMenuImg: `background: url(${require('../../assets/img/menu.png')})`,
      closeMobileMenuImg: `background: url(${require('../../assets/img/closeMenu.png')})`,
      closeTime: '' //低频彩开奖结束时间
    };
  },
  computed: {
    ...mapState(['device', 'bannerList', 'qiniuUrl']),
    menus() {
      return menus[this.$route.params.betType];
    },
    betType() {
      return this.$route.params.betType;
    },
    showTimeDom() {
      if (this.dataSource.issueID == this.dataSource.lastIssueID) {
        this.showTime = '停售中';
        return `<span class="stateText">停售中...</span>`;
      }

      if (this.second >= 0) {
        let arr = formatSeconds(this.second);

        let str = '';
        str += arr[0] === '00' ? '' : `<span class="num">${arr[0]}</span>时`;
        str += `<span class="num">${arr[1]}</span>分`;
        str += `<span class="num">${arr[2]}</span>秒`;
        this.showTime = arr;
        // this.showTime = "开奖中";
        return str;
      }
      if (this.second < 0 && this.second > -10) {
        this.showTime = '开奖中';
        return `<span class="stateText">开奖中...</span>`;
      }
      if (this.second <= -10) {
        this.showTime = '开奖中';
        return `<span class="stateText">开奖中...</span>`;
      }
    }
  },

  destroyed() {
    clearInterval(this.timeDown);
    clearTimeout(this.resTimeOut);
  },
  methods: {
    async init() {
      if (this.betType == 'lhc') {
        this.modeType = this.$route.query.modeType || 'LhcJishikaijiang';
      } else {
        this.modeType = this.$route.query.modeType || 'Jishikaijiang';
      }
      //六合彩 体彩类无动画
      if (this.betType != 'lhc' && this.betType != 'three') {
        this.videoImg = require(`../../assets/img/${this.betType}.png`);
        this.videoUrl = `${window.location.origin}/static/animate/${this.betType}/index.html`;
      }

      await this.getData();
    },

    initIframe() {
      this.videoUrl = `${window.location.origin}/static/animate/${this.betType}/index.html`;
      this.$nextTick(() => {
        const $iframe = document.querySelector('iframe');

        // console.log("$iframe", document.querySelectorAll("iframe"));
        const data = GenerateData[this.betType](this);
        $iframe.onload = () => {
          $iframe.contentWindow.pubmethod.init(this.betType, data, {
            flag: false
          });
        };
      });
    },
    setLoading(type, state) {
      if (type == 'page') {
        this.loading.page = state;
        this.loading.mode = false;
      }
      if (type == 'mode') {
        this.loading.mode = state;
      }
    },

    async getData() {
      clearInterval(this.timeDown);
      clearTimeout(this.resTimeOut);

      let gameType = this.$route.params.gameType;
      let res = await this.$store.dispatch('querySaleGameInfo', { gameType });

      this.dataSource = Object.assign({}, res.data.returnMap);
      this.getChildrenData();
      // 是否需要获取当前上期开奖号码
      if (res.data.returnMap.lastIssueID != res.data.returnMap.lastResultIssueID) {
        this.resTimeOut = setTimeout(() => {
          this.getData();
        }, 6000);
      } else {
        this.dataSource = Object.assign({}, res.data.returnMap);

        this.closeTime = dayjs(this.dataSource.closeTime).format('hh:mm');
        this.getChildrenData();

        this.second = (this.dataSource.GMTcloseTime - this.dataSource.GMTcurTime) / 1000;
      }

      //开奖倒计时
      //当处于开奖状态时请求开奖结果，每6s/次，非开奖状态正常倒计时1s/次
      if (this.second < 0) {
        clearInterval(this.timeDown);
        // console.log("1", this.second, this.isOpen);
        this.openTime = 6000;
        this.isOpen = true;
      } else {
        clearInterval(this.timeDown);
        // console.log("2", this.second, this.isOpen);
        this.openTime = 1000;
        this.isOpen = false;
      }
      this.timeDown = setInterval(() => {
        this.second--;
        if (this.second < 0) {
          // console.log("3", this.second, this.isOpen);
          this.isOpen = true;
          this.init();
          // this.initIframe();
        }
      }, this.openTime);
    },
    getChildrenData() {
      if (this.$refs[this.modeType] && this.$refs[this.modeType].init) {
        this.$refs[this.modeType].init();
      }
    },
    goto(type, index) {
      window.location.href = `/Trend/${this.$route.params.betType}/${this.$route.params.gameType}${type ? '?modeType=' + type : ''}`;
    },
    handleLinkSite(data) {
      if (data.isTurn == 1) {
        window.open(data.url, '_blank');
      } else {
        return;
      }
    },

    // 子组件 标注选择方法
    checkAllGroupChange(list) {
      var lostList = document.querySelectorAll('.lost_info');
      var canvas = document.querySelector('.cvs_container');
      var divide = document.querySelectorAll('.divide_lost_info');
      for (let i = 0; i < divide.length; i++) {
        const e = divide[i];
        e.parentNode.parentNode.classList.remove('lost_active');
      }
      if (!list.includes('yilou')) {
        for (let i = 0; i < lostList.length; i++) {
          const e = lostList[i];
          e.style.display = 'none';
        }
      } else {
        for (let i = 0; i < lostList.length; i++) {
          const e = lostList[i];
          e.style.display = 'inline-block';
        }
      }
      if (!list.includes('zhexian')) {
        canvas.style.display = 'none';
      } else {
        canvas.style.display = 'inline-block';
      }
      if (list.includes('yifen')) {
        for (let i = 0; i < divide.length; i++) {
          const e = divide[i];
          e.parentNode.parentNode.classList.add('lost_active');
        }
      } else {
        for (let i = 0; i < divide.length; i++) {
          const e = divide[i];
          e.parentNode.parentNode.classList.remove('lost_active');
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import url('./index.less');
@media screen and (max-width: 1200px) {
  #Trend {
    width: 100% !important;
    // .advertising {
    //   img {
    //     width: 48%;
    //   }
    // }
    #Road {
      width: 100% !important;
    }
  }
}
.small-video {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 347px;
  height: 290px;
  z-index: 99;
  border: 1px solid #ccc;
  .video-header {
    display: flex;
    justify-content: space-between;
    padding: 20px;
    background: #fff;
    p {
      font-size: 20px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Trend/index.vue